import React, {memo} from "react";
import SwitchItems from "../../../../Components/FormBuilder/Builder/FormInputs/SwitchItems";
import {getSelectedValueBasedOnField, isSet} from '../../../../Utils/CommonFunctions';
import isEqual from 'lodash/isEqual';
import { connect } from "react-redux";
import CurrencyTypeFields from "../../DetailView/DetailMainview/DetailViewBasicDetails/CurrencyTypeField";

const SubFormItem = (props) => {
  const {
    item,
    modType,
    keyIndex,
    subFormIndex,
    // columnData,
    columnIndex,
    rowIndex,
    pageType,
    subformValidation,
    reminderDisplayText,
    rowId,
    isOpenBox,
    section
  } = props;

  let styles = (item.element === 'CheckBoxes') ? {position: 'relative', top: '-16px'} : {};
  const { reminder,files,selectedValue,selected_value_text,selecteddpnm,overridden,currency_code,from_currency,exchange_rate,options} = props;
  let elementObj = {element_original: item.element};

  if (['PickList', 'MultiSelect', 'User', 'Lookup', 'MultiLookup'].includes(item.element)) {
    elementObj = {
      element: 'CustomAll',
      element_original: item.element,
    };
  }

  if (['Image', 'File'].includes(item.element)) {
    elementObj = {
      element: 'CustomAllFiles',
      element_original: item.element,
    };
  }

  const updatedItem = {
    ...item,
    options: isSet(options, item.options),
    reminder,
    files,
    selectedValue,
    selectedValueText: selected_value_text,
    displayValue: selecteddpnm,
    overridden,
    id: `${item.id}_${rowIndex}_${rowId}`,
    modType,
    currency_code,
    from_currency,
    exchange_rate,
    ...elementObj
  };
  const fieldObj = {
    section_index: section.section_index,
    itemIndex: item.itemIndex,
    modType,
    item: updatedItem,
    rowIndex,
    subFormIndex,
    columnIndex
  };

  const isCurrency = item.element === 'Currency' || updatedItem.element_original === 'Currency';
  // Same closed display as detail view: amount + to-currency code (exchange rate only when conversion is on and preferred is off).
  const closedDisplay = isCurrency ? (
    <CurrencyTypeFields
      displaySelectedValue={getSelectedValueBasedOnField(updatedItem)}
      currency_code={currency_code}
      has_currency_conversion={item.has_currency_conversion}
      exchange_rate={exchange_rate}
    />
  ) : getSelectedValueBasedOnField(updatedItem);

  return (
    <td key={rowIndex + '_' + keyIndex}>
      {(isOpenBox === true || pageType === 'form') ? (
        <div style={{...styles}}>
          <SwitchItems
            {...props}
            layoutForms={true}
            formType={'SUBFORM'}
            modType={'ADDFORM'}
            fieldObj={fieldObj}
            item={updatedItem}
            reminderDisplayText={reminderDisplayText}
          />
          {isSet(subformValidation[item.id], null) !== null && (
            <div>
              <span className="text-danger m-1">
                {isSet(subformValidation[item.id][rowIndex], '')}
              </span>
            </div>
          )}
        </div>
      ) : closedDisplay}
    </td>
  );
};

const isDiffProps = (prevProps, nextProps) => {
  if (
    prevProps.currency_code === nextProps.currency_code &&
    prevProps.from_currency === nextProps.from_currency &&
    prevProps.exchange_rate === nextProps.exchange_rate &&
    isEqual(prevProps.selectedValue, nextProps.selectedValue) &&
    isEqual(prevProps.options, nextProps.options) &&
    prevProps.item.access_mode === nextProps.item.access_mode &&
    prevProps.item.required === nextProps.item.required &&
    prevProps.isOpenBox === nextProps.isOpenBox &&
    isEqual(prevProps.subformValidation[prevProps.item.id], nextProps.subformValidation[nextProps.item.id])
  ) {
    return true; 
  }

  return false; 
};


const mapDispatchToProps = dispatch => {
  return {
  };
}
const mapStateToProps = (state,props) => { 
  return {
      subformValidation:state.formBuilder.subformValidation[props.modType],
  };
}
export default
  connect(
    mapStateToProps, 
    mapDispatchToProps
  )(memo(SubFormItem,isDiffProps));
